// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> millcroft-apartments-townhomes
// Generated: 2026-10-22T20:06:27.686Z
// Counts: 1 design, 67 content, 64 slot group, 3 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 & 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 & 2 Bedroom Apartments & Townhomes for Rent in Milford , OH</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Millcroft Apartments & Townhomes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the heart of Milford, Millcroft Apartments & Townhomes offers a serene retreat surrounded by nature and vibrant community life. Enjoy easy access to local parks, top-rated schools, and essential services. Experience the perfect blend of tranquility and convenience, making your home a launchpad for adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life and Love in Your New Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, vibrant living meets modern convenience. Enjoy a sun-soaked sundeck by the swimming pool, stay active with our basketball and pickleball courts, and unwind in our cozy resident lounge. Embrace a lifestyle that celebrates comfort and community, all in a pet-friendly environment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour the community from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, embrace a vibrant lifestyle with one and two-bedroom floor plans that cater to your every need. Enjoy amenities like a refreshing swimming pool, engaging resident activities, and pet-friendly spaces, all designed to make each day extraordinary. Lease online today and find your perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, a perfect blend of comfort and style awaits. Choose from spacious one or two-bedroom floor plans tailored to suit your lifestyle. Have questions? Our friendly leasing team is here to help you find your next home sweet home—reach out today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, your ideal living space awaits. Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Each layout enhances your lifestyle. Browse our available apartment homes today and envision the perfect blend of comfort and modern living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, vibrant living meets modern comfort. With spacious one and two-bedroom floor plans, a refreshing swimming pool, and amenities like a dog park and basketball court, this community is perfect for everyone. Picture yourself relaxing on the sundeck or enjoying resident activities today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the heart of Milford, Millcroft Apartments & Townhomes offers a serene retreat surrounded by nature and vibrant community life. Enjoy easy access to local parks, top-rated schools, and essential services. Experience the perfect blend of tranquility and convenience, making your home a launchpad for adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Milford , OH</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $350 and monthly pet rent is $50.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to Millcroft Apartments &amp; Townhomes, a vibrant rental community that ticks all the boxes for comfortable suburban living in Milford, Ohio. Choose from extra-spacious <a href=\"https://www.millcroftapts.com/floor-plans/\">one and two bedroom apartments and townhomes i</a> n a lush garden-style setting. Our welcoming community is just 18 miles northeast of Cincinnati for easy commuting. But with modern, updated interiors, and an impressive array of community amenities for your enjoyment, you’ll find little reason to leave your suburban oasis in Miami Township.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Millcroft Apartments & Townhomes in Milford, OH, where your comfort meets convenience. Our diverse floor plans include spacious one and two-bedroom options designed to fit your lifestyle. Access your resident portal for easy rent payments, maintenance requests, and exclusive community updates—all just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Millcroft Apartments & Townhomes in Milford, OH, your perfect living space awaits with stylish one and two-bedroom floor plans. Experience the vibrant community life and exceptional amenities that make us home. Schedule a tour today and hear firsthand from our residents about their experiences living here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Millcroft Apartments & Townhomes in Milford, OH! Your interest in our spacious one and two-bedroom floor plans is appreciated. Our team will be in touch soon to help you find the perfect home tailored to your lifestyle. Stay tuned for exciting updates!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-f180-71fe-8b15-7dd560968442.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment kitchen with white upper cabinets, dark lower cabinets, granite countertops, and stainless steel appliances."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1393-7658-a79c-86006855cf89.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor fitness center with treadmills, ellipticals, free weights, and a mirrored wall."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e4ad-712f-b142-6e4f72a9434b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern community lounge with gray seating, a fireplace, TV, and round glass dining table."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1393-7658-a79c-86006855cf89.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor fitness center with treadmills, ellipticals, free weights, and a mirrored wall."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-2bda-7555-b6e1-a1df4b837254.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with several top-loading washers and front-loading dryers."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e43c-764f-b851-798e13281d15.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brick accent wall, neutral furniture, and sheer white curtains."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-0623-76c2-8018-2941b81828a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright bedroom in an apartment with a wooden bedframe, ceiling fan, and white curtains over a window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-f180-71fe-8b15-7dd560968442.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with white upper cabinets, dark lower cabinets, granite countertops, and stainless steel appliances."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-397a-724b-a38f-8e865681686b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick apartment building with balconies and a grassy lawn."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Milford Trailhead, a scenic paved riverside trail popular for biking, hiking, and walking."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a0fd-720b-94e8-d530940fde7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Riverside Park in Milford with river views, a playground, and picnic areas."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4cb0-7513-9a3a-cedf65798c26.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "20 Brix, a nearby wine bar and eatery in downtown Milford."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-22de-763d-8632-56fed03825ab.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool at an apartment community with lounge chairs and striped umbrellas."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-21b4-77af-bdce-00c2f90449c8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool with striped umbrella, lounge chairs, and brick buildings."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-32d8-7328-a889-388fe9ff2beb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground structure in a grassy community yard with benches and a wooden pergola."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166332/019d0268-25e7-74c8-a92e-a297785720fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Millcroft Bark Park with black fence, pet waste station, and dog bone sign."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$125"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$15"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$59–$124"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce6c-42e3-73fe-8b46-bd7aab414f06.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-ec74-747f-8b91-88201251ead1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Compact apartment kitchen with white cabinets, black appliances, and a dining nook."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce6c-4a1b-7621-9fe5-6df0f1d5e215.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e47d-749f-bcea-56a9bf4f5abc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-e6ea-70bf-98e3-a534b4a25d31.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a neutral apartment with a brick accent wall, large windows, and seating."
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-2e6f-734f-9425-e966f39c8a44.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas next to brick buildings."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4cfe-7701-b252-817712f502a2.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Forager Coffee + Tea"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Trendy, homey coffee shop dishing up espresso drinks and teas, plus pastries and baked goods, including vegan options."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-ae66-72f3-a971-4192e5385952.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "EastGate Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling mall with a whimsical atrium, major department stores, brand-name chains, personal services and quick eats."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9ce2-747b-8c35-1346c4012d26.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Shor Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Scenic 56-acre park with paved walking paths, one of the county's first inclusive playgrounds, picnic shelters, and restored wetlands and rain gardens."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4d2d-7520-999c-dbdc341bf42d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Governor"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brunch & Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern diner and bar offering an eclectic menu of comfort food for breakfast, lunch, and dinner."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8d89-703f-8dd0-af07f082a889.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Row House Gallery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Downtown Milford gallery displaying works, often by local artists, with an on-site framing service to ensconce them."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Milford Trailhead"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Scenic, paved trail along the Little Miami River that's popular for biking, hiking and walking."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-53b7-7338-8bf2-b42e6c2cdcdf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cincinnati Distilling"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Cocktails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Historic mill offering craft spirits and cocktails, plus a dining room and rooftop bar."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5abd-76fe-884e-64a8e040ef95.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "By Golly's Milford"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Unassuming local bar & grill offering diverse pub food, live music & karaoke, plus a covered patio."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4cb0-7513-9a3a-cedf65798c26.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "20 Brix"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Classy wine bar & eatery offering modern American dishes with Mediterranean flair, plus a wine store."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-53c6-7440-8371-a5e7138db165.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Nation Kitchen & Bar Milford"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Late-Night"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Energetic, relaxed eatery serving burgers and fries (and a deal for both), along with cocktails."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8008-7248-bd50-50f5c753d0ce.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinemark Milford 16"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern multiplex with multiple screens, stadium seating and self-service ticketing kiosks for a night at the movies."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-52e2-77b9-91fd-3d9dc793bef6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Padrino"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual parlor known for dishing specialty pizzas, pastas, salads & drinks in a vintage building."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 37,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 40,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 38,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_2158dc79-feee-4ad9-b7ef-d310937e50fb",
      "custom_577ae7eb-2fae-4008-892c-01c12208ad83",
      "custom_ec756cc2-3ad7-497b-90fe-5a10f854f54c",
      "custom_63345ff9-7983-4e88-8a84-048b395ffdec",
      "custom_0105b410-e954-4106-921f-5e25621aad29",
      "custom_4f05d99e-2927-410b-b14d-75acd2aefc9d",
      "custom_51a56208-51c9-4361-8c24-b10b08824176",
      "custom_dd6f193e-1119-4053-8970-511c3ef1888c",
      "custom_9e669ade-87ed-4b0e-be4f-875b6f63af83",
      "custom_ec7777b3-5247-437d-8234-0c581edda17e",
      "custom_6bdaf649-3517-4b36-bdcf-344132e235f2",
      "custom_5c1a7966-036e-42a3-be78-da516e026488",
      "custom_de06891b-7fbb-4e04-a904-ca8db0f429b3",
      "custom_e42c81c5-ffdb-47a6-b8d8-7a71accd5115",
      "custom_82166962-0f77-4713-b38d-55466d89825f",
      "custom_3fb96c3e-8362-46d7-bb0c-f807ca379bdf",
      "custom_a968ab1b-2f44-49fc-8a49-6a684e60f511",
      "custom_baac9d9a-d22a-46ba-a700-96dd53852e85",
      "custom_0f82001c-0dfd-43d2-a6ee-b95ed1064f5b",
      "custom_77269ebf-f149-4c32-b24f-85d4482d152b",
      "custom_57d4d484-176a-4c1a-8dd5-4c2d83075d5c",
      "custom_66b4b979-67ef-4495-a833-75da889bfd93",
      "custom_a16605be-ac00-41c0-a26d-f7d0f1b5ca47",
      "custom_7ba3f861-05c9-406b-89d0-3c17ec54bf9a",
      "custom_99ef1a97-07cf-4578-ab8e-f343e4f7b490",
      "custom_93c84647-1f2a-49de-815b-760a82b98d8f",
      "custom_c17cc6c2-b1a4-40f6-8d39-a8f397565dc3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "custom_e42c81c5-ffdb-47a6-b8d8-7a71accd5115",
      "custom_5c1a7966-036e-42a3-be78-da516e026488",
      "custom_f11036a5-84d5-48ff-91fc-b2d40acf0f4d"
    ],
    "orderedIds": [
      "custom_93c84647-1f2a-49de-815b-760a82b98d8f",
      "custom_dd6f193e-1119-4053-8970-511c3ef1888c",
      "custom_0105b410-e954-4106-921f-5e25621aad29",
      "custom_51a56208-51c9-4361-8c24-b10b08824176",
      "custom_0f82001c-0dfd-43d2-a6ee-b95ed1064f5b",
      "custom_ec7777b3-5247-437d-8234-0c581edda17e",
      "custom_6bdaf649-3517-4b36-bdcf-344132e235f2",
      "custom_77269ebf-f149-4c32-b24f-85d4482d152b",
      "custom_3fb96c3e-8362-46d7-bb0c-f807ca379bdf",
      "custom_c17cc6c2-b1a4-40f6-8d39-a8f397565dc3",
      "custom_7ba3f861-05c9-406b-89d0-3c17ec54bf9a",
      "custom_63345ff9-7983-4e88-8a84-048b395ffdec",
      "custom_9e669ade-87ed-4b0e-be4f-875b6f63af83",
      "custom_4f05d99e-2927-410b-b14d-75acd2aefc9d",
      "custom_5c1a7966-036e-42a3-be78-da516e026488",
      "custom_de06891b-7fbb-4e04-a904-ca8db0f429b3",
      "custom_e42c81c5-ffdb-47a6-b8d8-7a71accd5115",
      "custom_a968ab1b-2f44-49fc-8a49-6a684e60f511",
      "custom_baac9d9a-d22a-46ba-a700-96dd53852e85",
      "custom_2158dc79-feee-4ad9-b7ef-d310937e50fb",
      "custom_577ae7eb-2fae-4008-892c-01c12208ad83",
      "custom_66b4b979-67ef-4495-a833-75da889bfd93",
      "custom_a16605be-ac00-41c0-a26d-f7d0f1b5ca47",
      "custom_ec756cc2-3ad7-497b-90fe-5a10f854f54c",
      "custom_99ef1a97-07cf-4578-ab8e-f343e4f7b490",
      "custom_57d4d484-176a-4c1a-8dd5-4c2d83075d5c",
      "custom_e321d034-5912-4267-ad98-815e74b49741",
      "custom_d633907f-46c0-4538-9be8-8ff07a145475",
      "custom_3d6fd47c-b239-4194-9313-42d93fc8c760",
      "custom_c84c48d9-de56-44c5-98e5-68d32fd59cdb",
      "custom_4f930827-9a0d-4d23-876e-c54e520212ad",
      "custom_7a0a5d94-69e4-4702-b1ae-902c56b1b051",
      "custom_fa86a0a6-962d-4e57-a55c-42ec324974b5",
      "custom_4b55373c-4481-4162-845f-f5116d7b975c",
      "custom_8140a9f8-8ffb-41ce-8187-eed91dc8c925",
      "custom_d4dd6ec0-46b8-4674-9a5d-ea30897c92a0",
      "custom_82166962-0f77-4713-b38d-55466d89825f",
      "custom_16b8b0c3-bbe7-4aeb-9750-554c17878db4",
      "custom_24cfcec0-8e1c-470c-9f12-06e699d9ac23",
      "custom_f11036a5-84d5-48ff-91fc-b2d40acf0f4d",
      "custom_c1d54823-16ca-4eef-a31e-e05138e2e7cf",
      "custom_61f722e8-a8c9-47aa-b7b6-c553b39b275a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": [
      "custom_d8f7f547-b101-4fa4-afbb-248803396bf2"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
